import React, { useEffect, useState, useRef } from "react";
import "./SectionTwo.css";

function SectionTwo() {
  const [traditionalPrice, setTraditionalPrice] = useState("Agent fee will appear here.");
  const [dDPrice, setDDPrice] = useState("10000");
  const [price, setPrice] = useState("0");
  const btRef = useRef(null);
  // const handleCalculate = () => {
  //   if (price !== "0") {
  //     setDDPrice((price * 1) / 100);
  //     setTraditionalPrice((price * 3) / 100);
  //   }
  // };
  const handleCalculate = () => {
    // Remove all non-numeric characters (like commas) from the price string
    const numericPrice = price.replace(/[^0-9]/g, "");
  
    // Convert the cleaned string to a number
    const priceAsNumber = parseFloat(numericPrice);
  
    // Check if the price is a valid number and not zero
    if (!isNaN(priceAsNumber) && priceAsNumber !== 0) {
      setDDPrice(priceAsNumber / 100);
      setTraditionalPrice("$ "+formatPrice((priceAsNumber * 3) / 100));
    }
  };
  const formatPrice = (price) => {
    return parseInt(price).toLocaleString("en-US");
  };
  const [isMobile, setIsMobile] = useState(false);
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 980);
    };

    handleResize();

    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);
  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      btRef.current.click();
    }
  };
  return (
    <div className="section-two">
      <div className="container-fluid px-0">
        <div className="row px-0 mx-0">
          <div className="col-12 px-0">
            <div className="section-two-header">
              <img
                src="/img/section-two-header-line.svg"
                className="img-fluid section-two-header-line"
                alt=""
              />
            </div>
          </div>
          <div className="col-12">
            <div className="section-two-content">
              <div className="container-fluid">
                <div className="row mx-0 px-0">
                  <div className="col-12 d-flex justify-content-center">
                    <span className="section-two-h1">
                      {/* How much do you save? */}
                      Imagine the possibilities! How much could you save by
                      starting today?
                    </span>
                  </div>
                  <div className="col-12 d-flex justify-content-center">
                    <div className="input-group section-two-input-group mb-3">
                      <button
                        className="btn section-two-dollar-icon"
                        type="button"
                      >
                        <img
                          src="/img/section-two-dollar.svg"
                          className="img-fluid"
                          alt=""
                        />
                      </button>

                      <input
                        type="text"
                        className="form-control section-two-input"
                        placeholder="Enter Purchase Price"
                        aria-label="Recipient's username"
                        aria-describedby="button-addon2"
                        required
                        onChange={(e) => setPrice(e.target.value)}
                        onKeyDown={handleKeyDown} // Detect Enter key
                      />
                      <button
                        className="btn section-two-calculate-button"
                        type="button"
                        onClick={handleCalculate}
                        ref={btRef}
                      >
                        Calculate
                      </button>
                    </div>
                  </div>
                  <div className="col-12 d-flex justify-content-center">
                    <span className="section-two-h2">
                      {/* Here are your savings */}
                      Discover the incredible potential of your savings!
                    </span>
                  </div>
                  <div className="col-12 d-flex justify-content-center section-two-cards-container">
                    <div
                      className={`${isMobile ? "container-fluid" : "container"} section-two-cards-container`}
                    >
                      <div className="row mx-0 px-0">
                        <div className="col-lg-6">
                          <div className="section-two-card-1">
                            <div className="section-two-card-1-image-group">
                              <span className="section-two-card-1-heading">
                                Traditional Agent
                              </span>
                            </div>
                            <div className="section-two-card-1-price-group">
                              <span
                                className="section-two-card-1-price"
                                style={{ fontFamily: "Degular-Bold" }}
                              >
                                {traditionalPrice} 
                           
                              </span>
                           
                              <span className="text-white"    style={{ fontFamily: "Degular-Light", color: "#e1e1e1!important" }}>Based on an average 3% buyer agent fee</span>
                            </div>
                          </div>
                        </div>
                        <div className="col-lg-6">
                          <div className="section-two-card-2">
                            <div className="section-two-card-2-image-group">
                              <span className="section-two-card-2-heading">
                                Deal Direct Homes
                              </span>
                            </div>
                            <div className="section-two-card-2-price-group">
                              {/* <span
                                className="section-two-card-1-price"
                                style={{
                                  textDecoration: "line-through",
                                  textDecorationThickness: "1.2px",
                                  textDecorationColor: "#d4bb98",
                                }}
                              >
                                $ {formatPrice(traditionalPrice)}
                              </span> */}
                              <span className="section-two-card-2-price">
                                <span style={{ fontFamily: "Degular-Bold" }}>
                                  {/* No Realtor Fees */}
                                  $0.00 &nbsp;
                                </span>
                                {/* $ {formatPrice(dDPrice)} */}
                                Realtor Fees
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* <div className="col-12 d-flex justify-content-end">
            <div className="section-two-header">
              <img
                src="/img/section-two-footer-line.svg"
                className="img-fluid section-two-footer-line"
                alt=""
              />
            </div>
          </div> */}
        </div>
      </div>
    </div>
  );
}

export default SectionTwo;
